import { upperFirst, camelCase } from 'lodash';

var styles = {"alignLeft":"cYhXT","textWrapNowrap":"JljUC","alignRight":"B9D2L","alignCenter":"eQaNa","sizeFullWidth":"PGJU-","renderedInTable":"_1-LT3","sizeOriginal":"qgJBa","sizeContent":"rkxiU","sizeSmall":"T2fQM","sizeSmallCenter":"g-s3h","flex":"Fej9w","atomic":"jF0RO","anchor":"saNa6","embed":"rszgQ","horizontalScrollbar":"_4FccP","pluginContainerMobile":"d--6f"};

const getContainerData = (node) => {
  var _a;
  const data = `${camelCase(node.type)}Data`;
  return (_a = node == null ? void 0 : node[data]) == null ? void 0 : _a.containerData;
};
const getAlignmentClassName = (containerData = {}) => {
  const { alignment } = containerData;
  if (!alignment) {
    return "";
  }
  const key = `align${upperFirst(alignment.toLowerCase())}`;
  return styles[key];
};
const getSizeClassName = (containerData) => {
  const { width } = containerData;
  const { size } = width || {};
  if (!size) {
    return "";
  }
  const key = `size${upperFirst(camelCase(size.toLowerCase()))}`;
  return styles[key];
};
const getTextWrapClassName = (containerData = {}) => {
  const { textWrap } = containerData;
  if (textWrap) {
    return "";
  }
  return styles.textWrapNowrap;
};
const alignmentClassName = (node) => {
  return getAlignmentClassName(getContainerData(node));
};
const sizeClassName = (node) => {
  return getSizeClassName(getContainerData(node) || {});
};
const textWrapClassName = (node) => {
  return getTextWrapClassName(getContainerData(node));
};

export { getSizeClassName as a, getTextWrapClassName as b, alignmentClassName as c, sizeClassName as d, getAlignmentClassName as g, styles as s, textWrapClassName as t };
//# sourceMappingURL=getClassNames-87e1bc11.js.map
